module.exports = __webpack_public_path__ + "static/media/conferencebig.3fa5259d.jpg";